export default "__VITE_ASSET__832b2575__"